module.exports = __webpack_public_path__ + "img/png.c8c7fa2e.svg";